import { CheckCircle2, XCircle } from "@/components/icons";

const STATE_LABEL = {
  pending: "Pendiente de confirmación",
  confirmed: "Confirmada",
  declined: "No asistirá",
};

export default function ResultState({ state }) {
  const isConfirmed = state === "confirmed";
  return (
    <div className="mt-7 text-center" data-testid="confirm-already-state">
      {isConfirmed ? (
        <>
          <div className="w-14 h-14 mx-auto rounded-full bg-blue-50 border border-emerald-200 flex items-center justify-center">
            <CheckCircle2 className="w-7 h-7 text-[#019A75]" />
          </div>
          <h2 className="mt-4 text-xl font-extrabold text-black">¡Cita confirmada!</h2>
          <p className="mt-1 text-sm text-black/60">
            Te esperamos. Si necesitas reprogramar, contacta al consultorio.
          </p>
        </>
      ) : (
        <>
          <div className="w-14 h-14 mx-auto rounded-full bg-red-100 border border-red-200 flex items-center justify-center">
            <XCircle className="w-7 h-7 text-red-700" />
          </div>
          <h2 className="mt-4 text-xl font-extrabold text-black">
            Marcaste que no podrás asistir
          </h2>
          <p className="mt-1 text-sm text-black/60">
            Hemos liberado el horario. Si quieres reprogramar, contacta al consultorio.
          </p>
        </>
      )}
      <p className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-black/5 text-black/70 text-xs font-bold">
        Estado: {STATE_LABEL[state]}
      </p>
    </div>
  );
}
